import { Card, CardActionArea, CardContent, CardMedia, Skeleton, Tooltip, Typography, useTheme } from '@mui/material';
import PropTypes from "prop-types";
import { getUserHasAccess } from '../../utils/authorities';
import { useSelector } from 'react-redux';
import { EditIcon } from '../../assets/common-svg/CommonSvg';
import { useNavigate } from "react-router";

export const CustomHeaderCard = ({ editIcon, handleEditIcon, startIcon, endIcon, DetailsArray, loading, SubjectData }) => {
  const LoginData = useSelector((state) => state.loginData);
  const userAuthority = LoginData?.auth || [];
  const theme = useTheme();
  const navigate = useNavigate();
  const {role_id, role_slug} = LoginData;

  const handleVisitUrl = () => {
  const url =  `/phases/phase-details/${SubjectData?.phase_id}/patient-details/${SubjectData?.id}/inbound-form/${SubjectData?.qr_code}`;
  navigate(url);
  }
  
  return (
    <Card 
    // sx={{ maxWidth: { xs: "100%", md: 345 } }}
    >
      <CardActionArea>
        <CardContent>
          <div className="flex gap-2 md:gap-4">
            <div>
              {loading ? (
                <Skeleton variant="circular" width={80} height={80} />
              ) : (
                startIcon
              )}
            </div>
            <div className="flex flex-col">
              {loading ? (
                <Skeleton width={200} height={20} />
              ) : (
                <div className='d-flex'>
                <Tooltip title={SubjectData?.code || ''} placement="top">
                  <span>
                    <Typography
                      className="sub-code w-[90%]  !break-all"
                      variant="body1"
                      color="secondary"
                    >
                      {SubjectData?.code}
                    </Typography>
                  </span>
                </Tooltip>
                <Tooltip title={"Edit Patient"} placement="top">
                  {editIcon && getUserHasAccess(
                    userAuthority,
                    "appointmentManager",
                    120
                  ) && <span style={{ pointerEvents: "painted" }} className=' cursor-pointer' onClick={() => handleEditIcon()}> <EditIcon /></span>}
                </Tooltip>
              </div>
              
              )}
              {loading ? (
                <Skeleton width={100} height={20} />
              ) : (
                <Typography className="text-sm md:text-base" variant="h5">
                  {SubjectData?.name}
                </Typography>
              )}
              {loading ? (
                <Skeleton width={80} height={20} />
              ) : (
                <div>
                <Typography
                  variant="body1"
                  fontWeight={theme.typography.fontWeightMedium}
                >
                  {SubjectData?.gender} {SubjectData?.age? (`${SubjectData?.age}`):''}{" "}
                </Typography>
                 {SubjectData?.qr_code && ['editor','project-manager','superadmin','investigator','trialmanager']?.includes(role_slug) && <a 
              className="font-medium  hover:text-blue-800 underline hover:underline cursor-pointer textModifyColor"
                                      onClick={() => handleVisitUrl()}
                                    >Visit Vein-To-Vein</a>}
                                    </div>
              )}
            </div>
          </div>
          <div className="grid grid-cols-2 gap-x-8 gap-y-4 capitalize pt-6 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 ">
            {DetailsArray.map((pair) => {
              return (
                <div className="flex flex-col" key={pair.FieldName}>
                  <Typography variant="body1" color={theme.palette.grey[400]}>
                    {pair.FieldName}
                  </Typography>
                  {loading ? (
                    <Skeleton width={150} height={20} />
                  ) : (
                    <Typography variant="body1" className='flex gap-2 align-items-center'>
                      {pair.Value}
                      {pair?.icon && pair?.icon?.status && getUserHasAccess(
                        userAuthority,
                        "subject_pending",
                        pair?.icon?.auth
                      ) && (
                          <Tooltip
                            className='pointer-events-all'
                            title={pair?.icon?.toolText}
                            onClick={() => pair?.icon?.event(pair?.icon.value, false)}
                          >
                            <div
                              className="cursor-pointer underline text-sm sm:text-base font-semibold"
                              style={{
                                color: "rgb(53, 113, 255)",
                                cursor: "pointer",
                                pointerEvents: "painted"
                              }}
                            >
                              {/* @info Remove icon if not superAdmin */}
                           {role_id === 1 && <EditIcon/>} 
                            </div>
                          </Tooltip>)}
                    </Typography>
                  )
                  }
                </div>
              );
            })}
          </div>
        </CardContent>
        <CardMedia className="p-3 flex justify-end items-end ">{endIcon}</CardMedia>
      </CardActionArea>
    </Card >
  );
}
CustomHeaderCard.proptypes = {
  main_heading_class: PropTypes.string,
  sub_heading_class: PropTypes.string,
  DetailsArray: PropTypes.array,
  NoWrap: PropTypes.bool,
  startIcon: PropTypes.node,
  endIcon: PropTypes.node
}